import { createAsyncThunk } from '@reduxjs/toolkit';

interface RevokeAdviserApprovalParams {
  uuid: string;
}

/**
 * Revoke an adviser's approval
 * Removes the adviser document approval property and deletes email lookup mapping
 */
export const revokeAdviserApprovalThunk = createAsyncThunk<
  void,
  RevokeAdviserApprovalParams
>(
  'advisers/revokeApproval',
  async ({ uuid }) => {
    console.log(`[Advisers] Revoking approval for adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/approval`, {
      method: 'DELETE'
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to revoke adviser approval: ${response.status}`);
    }

    console.log('[Advisers] Adviser approval revoked successfully');
  }
);
